<style scoped>
	#body {
		margin: 5px;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	}
	.el-form-item {
		margin-bottom: 0px;
	}
	.preview-img {
		width: 90px;
		max-height: 90px;
		object-fit: cover;
		border: solid 1px #dcdcdc;
		cursor: pointer;
	}
	.detail-row {
		display: flex;
		line-height: 24px;
		margin-bottom: 10px;
	}
	.detail-label {
		width: 120px;
		text-align: right;
		padding-right: 10px;
		color: #606266;
		flex-shrink: 0;
	}
	.detail-value {
		flex: 1;
		word-break: break-all;
	}
	.audit-box {
		display: flex;
		align-items: flex-start;
		margin-top: 15px;
	}
	.upload-content {
		width: 620px;
	}
	.upload-list {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		gap: 10px;
	}
	.upload-card {
		position: relative;
		width: 90px;
		height: 90px;
	}
	.upload-card img {
		width: 90px;
		height: 90px;
		object-fit: cover;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		display: block;
	}
	.upload-remove {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 20px;
		height: 20px;
		border: none;
		border-radius: 50%;
		background: #f56c6c;
		color: #fff;
		line-height: 20px;
		text-align: center;
		cursor: pointer;
		padding: 0;
		z-index: 2;
	}
	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 90px;
		height: 90px;
		line-height: 90px;
		text-align: center;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}
</style>

<template>
	<div id="body">
		<div style="box-shadow: 1px 1px 10px #DCDCDC; height: 40px; background-color: white; display: flex; flex-direction: row; align-items: center; margin: 0 10px; padding: 5px 5px 5px 20px; border-radius: 10px;">
			<el-button icon="el-icon-refresh-right" circle  @click="refresh" style="margin-right: 20px;"></el-button>
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>自定义广告</el-breadcrumb-item>
			  <el-breadcrumb-item>申请列表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="margin-top: 10px; background-color: white; padding: 10px; margin: 10px; border-radius: 5px;">
			<el-table :data="tableData" ref="myTable" border style="width: 100%"
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
				<el-table-column prop="id" label="编号" width="90" align="center"></el-table-column>
				<el-table-column prop="uid" label="会员ID" width="100" align="center"></el-table-column>
				<el-table-column label="会员账号" min-width="130" align="center">
					<template slot-scope="scope">
						<span>{{ getUserInfo(scope.row, 'username') }}</span>
					</template>
				</el-table-column>
				<el-table-column label="会员昵称" min-width="130" align="center">
					<template slot-scope="scope">
						<span>{{ getUserInfo(scope.row, 'nickname') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="game" label="彩种" width="110" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.game == 'jc'" type="primary">竞彩</el-tag>
						<el-tag v-if="scope.row.game == 'pl3'" type="success">排列三</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="ad_urls" label="申请图片" width="220" align="center">
					<template slot-scope="scope">
						<div class="upload-list">
							<img
								v-for="(item, index) in normalizeImageList(scope.row.ad_urls)"
								:key="index"
								class="preview-img"
								:src="item.img_full_url"
								@click="previewImg(item.img_full_url)" />
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="审核状态" width="110" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status == 0" type="warning">待审核</el-tag>
						<el-tag v-if="scope.row.status == 1" type="success">已同意</el-tag>
						<el-tag v-if="scope.row.status == 2" type="danger">已拒绝</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="申请时间" width="170" align="center"></el-table-column>
				<el-table-column prop="action_time" label="审核时间" width="170" align="center"></el-table-column>
				<el-table-column prop="action_urls" label="审核图片" width="220" align="center">
					<template slot-scope="scope">
						<div class="upload-list">
							<img
								v-for="(item, index) in normalizeImageList(scope.row.action_urls)"
								:key="index"
								class="preview-img"
								:src="item.img_full_url"
								@click="previewImg(item.img_full_url)" />
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="openAudit(scope.row)">审核</el-button>
						
						<el-button type="danger" size="mini" v-if="scope.row.status != 1" @click="eleteAudit(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="prev, pager, next" :key="tableKey" :page-size="limit" @current-change="getData" :total="total" style="margin-top: 20px;"></el-pagination>
		</div>

		<el-dialog title="广告申请审核" :visible.sync="auditView" width="820px" @close="closeAuditDialog">
			<div v-if="currentRow">
				<div class="detail-row">
					<div class="detail-label">编号：</div>
					<div class="detail-value">{{ currentRow.id }}</div>
				</div>
				<div class="detail-row">
					<div class="detail-label">会员ID：</div>
					<div class="detail-value">{{ currentRow.uid }}</div>
				</div>
				<div class="detail-row">
					<div class="detail-label">会员账号：</div>
					<div class="detail-value">{{ getUserInfo(currentRow, 'username') }}</div>
				</div>
				<div class="detail-row">
					<div class="detail-label">会员昵称：</div>
					<div class="detail-value">{{ getUserInfo(currentRow, 'nickname') }}</div>
				</div>
				<div class="detail-row">
					<div class="detail-label">彩种：</div>
					<div class="detail-value">{{ getGameName(currentRow.game) }}</div>
				</div>
				<div class="detail-row">
					<div class="detail-label">审核状态：</div>
					<div class="detail-value">{{ formatStatus(currentRow.status) }}</div>
				</div>
				<div class="detail-row">
					<div class="detail-label">申请时间：</div>
					<div class="detail-value">{{ formatValue(currentRow.add_time) }}</div>
				</div>
				<div class="detail-row">
					<div class="detail-label">审核时间：</div>
					<div class="detail-value">{{ formatValue(currentRow.action_time) }}</div>
				</div>
				<div class="audit-box">
					<div class="detail-label">申请图片：</div>
					<div class="upload-content">
						<div class="upload-list">
							<img
								v-for="(item, index) in normalizeImageList(currentRow.ad_urls)"
								:key="index"
								class="preview-img"
								:src="item.img_full_url"
								@click="previewImg(item.img_full_url)" />
						</div>
					</div>
				</div>
				<div class="audit-box">
					<div class="detail-label">审核状态：</div>
					<el-select style="width: 620px;" v-model="auditForm.status" placeholder="请选择审核状态">
						<el-option label="待审核" :value="0"></el-option>
						<el-option label="已同意" :value="1"></el-option>
						<el-option label="已拒绝" :value="2"></el-option>
					</el-select>
				</div>
				<div class="audit-box">
					<div class="detail-label">上传图片：</div>
					<div class="upload-content">
						<div class="upload-list">
							<div class="upload-card" v-for="(item, index) in actionImages" :key="item.img_url + index">
								<img :src="item.img_full_url" @click="previewImg(item.img_full_url)">
								<button type="button" class="upload-remove" @click.stop.prevent="removeActionImage(index)">×</button>
							</div>
							<el-upload class="avatar-uploader" :action="this.$http_url + '/Upload/UploadImage'" :headers="headers" :show-file-list="false"
								:on-success="UploadSuccess"
								:before-upload="beforeUpload"
								:on-error="UploadError">
								<i class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</div>
					</div>
				</div>
				<div style="width: 100%; margin-top: 25px;">
					<el-button style="width: 100%;" type="primary" @click="submitAudit">提交保存</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name:'AdSelfList',
		data(){
			return {
				auditView:false,
				currentRow:null,
				actionImages:[],
				auditForm:{
					id:'',
					status:'',
					action_urls:[]
				},
				headers:{
					Authorization:''
				},
				status:'',
				keyword:'',
				tableKey:0,
				loading:false,
				limit:10,
				total:0,
				tableData: []
			}
		},
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
			this.getData();
		},
		methods:{
			getGameName(_game){
				if(_game == 'jc') return '竞彩';
				return '排列三';
			},
			getUserInfo(row, key){
				if(row && row.userinfo && row.userinfo[key]){
					return row.userinfo[key];
				}
				return '-';
			},
			formatValue(value){
				if(value === null || value === undefined || value === ''){
					return '-';
				}
				if(Array.isArray(value)){
					return value.join('，');
				}
				if(typeof value === 'object'){
					return JSON.stringify(value);
				}
				return value;
			},
			formatStatus(status){
				if(status == 0){
					return '待审核';
				}
				if(status == 1){
					return '已同意';
				}
				if(status == 2){
					return '已拒绝';
				}
				return status;
			},
			getStatusType(status){
				if(status == 0){
					return 'warning';
				}
				if(status == 1){
					return 'success';
				}
				if(status == 2){
					return 'danger';
				}
				return 'info';
			},
			previewImg(_img){
				window.open(_img);
			},
			openAudit(row){
				this.currentRow = Object.assign({}, row);
				this.auditForm = {
					id:row.id,
					status:row.status === '' || row.status === undefined ? 0 : Number(row.status),
					action_urls:[]
				};
				this.actionImages = this.normalizeImageList(row.action_urls);
				this.auditView = true;
			},
			closeAuditDialog(){
				this.auditView = false;
				this.currentRow = null;
				this.actionImages = [];
				this.auditForm = {
					id:'',
					status:'',
					action_urls:[]
				};
			},
			eleteAudit(_row){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '删除中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/TplSet/DeleteAdApply", {id:_row.id}).then(res=>{
					loading.close();
					if(res.code == 1 || res.code == 200)
					{
						_this.$message({
							 message: '删除成功~',
							 type: 'success',
						});
						_this.getData();
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(res=>{
					loading.close();
				});
			},
			submitAudit(){
				if(this.auditForm.status === ''){
					return this.$message({ message: '请选择审核状态', type: 'warning' });
				}
				let _this = this;
				this.auditForm.action_urls = this.actionImages.map(item=>item.img_url);
				const loading = this.$loading({
						lock: true,
						text: '保存中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/TplSet/SaveAdApply", this.auditForm).then(res=>{
					loading.close();
					if(res.code == 1 || res.code == 200)
					{
						_this.$message({
							 message: '保存成功~',
							 type: 'success',
						});
						_this.closeAuditDialog();
						_this.getData();
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(res=>{
					loading.close();
				});
			},
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.actionImages.push({img_url: this.getImagePath(res.file_path), img_full_url: this.getImageFullUrl(res.file_path)});
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			removeActionImage(index){
				this.actionImages.splice(index, 1);
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			normalizeImageList(list){
				if(!list){
					return [];
				}
				let imageList = list;
				if(typeof imageList === 'string'){
					try{
						imageList = JSON.parse(imageList);
					}catch(e){
						imageList = imageList.split(',').filter(item=>item);
					}
				}
				if(!Array.isArray(imageList)){
					imageList = [imageList];
				}
				return imageList.map(item=>{
					const imgUrl = typeof item == 'string' ? item : (item.img_url || item.img_full_url || '');
					return {
						img_url:this.getImagePath(imgUrl),
						img_full_url:this.getImageFullUrl(imgUrl)
					};
				}).filter(item=>item.img_url);
			},
			getImagePath(url){
				if(!url){
					return '';
				}
				if(this.$http_host && url.indexOf(this.$http_host) === 0){
					return url.replace(this.$http_host, '');
				}
				return url;
			},
			getImageFullUrl(url){
				if(!url){
					return '';
				}
				if(/^https?:\/\//.test(url)){
					return url;
				}
				return this.$http_host + url;
			},
			refresh(){
				this.getData();
			},
			getData(page=1){
				let that = this;
				that.loading = true;
				that.$api.post("/TplSet/getAdsApply", {page:page, limit:this.limit}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			onSubmit(){
				this.getData();
			},
			statusChange(e){
				this.status = e;
				this.getData();
			},
		}
	}
</script>
